import { render, staticRenderFns } from "./SmartCatalogSearchV2.vue?vue&type=template&id=732ffa64&scoped=true"
import script from "./SmartCatalogSearchV2.vue?vue&type=script&lang=js"
export * from "./SmartCatalogSearchV2.vue?vue&type=script&lang=js"
import style0 from "./SmartCatalogSearchV2.vue?vue&type=style&index=0&id=732ffa64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732ffa64",
  null
  
)

export default component.exports